import { render, staticRenderFns } from "./fortunellaVenosaRule.vue?vue&type=template&id=401de6e6&scoped=true&"
import script from "./fortunellaVenosaRule.vue?vue&type=script&lang=js&"
export * from "./fortunellaVenosaRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401de6e6",
  null
  
)

component.options.__file = "fortunellaVenosaRule.vue"
export default component.exports